import React, { useState } from "react";

function EyeOpen() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        d="M1 8C1 8 3.5 3 8 3C12.5 3 15 8 15 8C15 8 12.5 13 8 13C3.5 13 1 8 1 8Z"
        stroke="currentColor"
        strokeWidth="1.35"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="8" cy="8" r="2" stroke="currentColor" strokeWidth="1.35" />
    </svg>
  );
}

function EyeClosed() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path d="M2 2L14 14" stroke="currentColor" strokeWidth="1.35" strokeLinecap="round" />
      <path
        d="M6.8 3.1C7.2 3.04 7.6 3 8 3C12.5 3 15 8 15 8C14.6 8.8 14.1 9.55 13.4 10.2"
        stroke="currentColor"
        strokeWidth="1.35"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.4 4.85C2.9 5.8 1.7 7.1 1 8C1 8 3.5 13 8 13C9.45 13 10.7 12.55 11.7 11.9"
        stroke="currentColor"
        strokeWidth="1.35"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M6 8C6 6.9 6.9 6 8 6" stroke="currentColor" strokeWidth="1.35" strokeLinecap="round" />
      <path d="M10 8.8C9.75 9.55 9 10 8 10" stroke="currentColor" strokeWidth="1.35" strokeLinecap="round" />
    </svg>
  );
}

export default function PasswordInput({ style, className, ...props }) {
  const [show, setShow] = useState(false);

  return (
    <div style={{ position: "relative", width: "100%", display: "block" }}>
      <input
        {...props}
        type={show ? "text" : "password"}
        className={className}
        style={{ ...style, paddingRight: "40px", boxSizing: "border-box" }}
      />
      <button
        type="button"
        tabIndex={-1}
        onClick={() => setShow((s) => !s)}
        style={{
          position: "absolute",
          right: "10px",
          top: "50%",
          transform: "translateY(-50%)",
          background: "none",
          border: "none",
          padding: "4px",
          cursor: "pointer",
          color: "var(--text-muted)",
          display: "flex",
          alignItems: "center",
          lineHeight: 0,
        }}
      >
        {show ? <EyeOpen /> : <EyeClosed />}
      </button>
    </div>
  );
}
